<template>
  <el-dialog
    title="选择内容链接"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false">
    <div class="content-wrap">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          label="门户内容"
          name="0">
          <message-info
            :linkType="0"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="商品"
          name="1">
          <goods-info
            :linkType="1"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="商品组"
          name="11">
          <goods-group-info
            :linkType="11"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="抽奖活动"
          name="3">
          <lottery-goods-info
            :linkType="3"
            @select="select" />
        </el-tab-pane>
        <!-- <el-tab-pane
          label="报名抽奖列表"
          name="13">

          </el-tab-pane> -->
        <el-tab-pane
          label="积分活动"
          name="4">
          <!-- <integral-task :linkType="4" /> -->
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:4, link: 15, contentType: 1 , title: '步数兑换'})">
            步数兑换
          </el-tag>
        </el-tab-pane>
        <!-- <el-tab-pane
        label="积分活动列表"
        name="14"></el-tab-pane> -->
        <el-tab-pane
          label="限时优惠"
          name="5">
          <discount-goods-info
            :linkType="5"
            @select="select" />
        </el-tab-pane>
        <el-tab-pane
          label="专区"
          name="6">
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:6, link: null, title: '限时优惠专区'})">
            限时优惠专区
          </el-tag>
          <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:13, link: null, contentType: 1 , title: '报名抽奖专区'})">
            报名抽奖专区
          </el-tag>
          <!-- <el-tag
            type="success"
            effect="plain"
            @click="select({linkType:13, link: null, contentType: 2 , title: '积分抽奖专区'})">
            积分抽奖专区
          </el-tag> -->
        </el-tab-pane>
      </el-tabs>
    </div>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        关 闭
      </el-button>
      <!-- <el-button
        type="primary"
        :loading="loading"
        @click="addTemplate(-1)">自定义</el-button> -->
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import LotteryGoodsInfo from './busi-content/lottery-goods-info'
import DiscountGoodsInfo from './busi-content/discount-goods-info.vue'
import GoodsGroupInfo from './busi-content/goods-group-info.vue'
import GoodsInfo from './busi-content/goods-info.vue'
// import IntegralTask from './busi-content/integral-task.vue'
import MessageInfo from './busi-content/message-info.vue'
export default {
  name: 'ContentSelectModal',
  components: { MessageInfo, GoodsInfo, DiscountGoodsInfo, LotteryGoodsInfo, GoodsGroupInfo },
  data() {
    return {
      loading: false,
      visible: false,
      activeName: '',
      selectList: [],
      row: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  methods: {
    select(item) {
      console.log(item)
      this.$emit('handleSelect', item, this.row.$index)
      this.toggleModal(false)
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClick() {},
    init(row, $index) {
      this.row = {
        ...row,
        $index
      }
      this.toggleModal(true)
    }
  }
}
</script>
<style lang="stylus">
.content-wrap {
  .el-tabs__content {
    height: 400px;
  }

  .el-tag {
    cursor: pointer;
  }

  .el-tag+.el-tag {
    margin-left: 8px;
  }
}
</style>
